// Shared adoption of server-provided profile display copy.
//
// The API now ships a plain-English `label` + `why` on every deck-profile
// entry (and a `summary` per surface) — see
// ~/github/api-changes-profile-display-copy.md. The client renders those
// verbatim and only falls back to its own copy tables for payloads that
// predate the change (decks re-derive lazily, so cached ones lack the fields).
//
// These helpers centralize the "prefer server copy, else fall back" rule so
// every surface adopts it identically instead of re-implementing the guard.

const isNonEmptyString = (v) => typeof v === 'string' && v.trim().length > 0;

// Prefer the server string; fall back to the client-derived one. Returns the
// fallback when the server value is missing/blank so nothing regresses on old
// cached decks.
export function preferServerCopy(serverValue, fallback) {
    return isNonEmptyString(serverValue) ? serverValue : fallback;
}

// Resolve an entry's { label, why } — server copy wins, client copy fills gaps.
// `fallback.label` / `fallback.why` are whatever the surface derived before.
export function resolveEntryCopy(entry, fallback = {}) {
    return {
        label: preferServerCopy(entry?.label, fallback.label),
        why: preferServerCopy(entry?.why, fallback.why),
    };
}

// Resolve a surface-level summary sentence (server-provided) with a fallback.
export function resolveSummary(serverSummary, fallback = null) {
    return preferServerCopy(serverSummary, fallback);
}
